import StatementPayment from '@/@types/statement/statementPayment';
import { StatementPaymentStateInterface } from './types';

export default {
  getStatementPayment(state: StatementPaymentStateInterface): StatementPayment {
    return state.statementPayment;
  }
};
